<div class="row pt-2">
    <div class="col" style="display: contents">
        <div class="me-2 border rounded ms-2" [style.height.px]="tableHeight">
            <table class="table table-sm table-borderless table-hover" style="max-width: 400px; width: 350px;">
                <thead>
                    <tr class="row-cols-auto">
                        <th>
                            Search by Trucker
                            <input type="text" class="form-control form-control-sm" id="searchByTrucker" name="searchByTrucker" [(ngModel)]="searchTrucker" (ngModelChange)="filterTruckersList()" />
                        </th>
                        <th>
                            Search by Code
                            <input type="text" class="form-control form-control-sm" id="searchByCode" name="searchByCode" [(ngModel)]="searchCode" (ngModelChange)="filterTruckersList()" />
                        </th>
                    </tr>
                </thead>
                <thead>
                    <tr class="row-cols-auto">
                        <th scope="col" class="col-sm-auto text-start">Name</th>
                        <th scope="col" class="col-sm-auto text-start">Code</th>
                        <th scope="col" class="col-sm-auto text-center" style="min-width: 100px;">Executed</th>
                    </tr>
                </thead>
                <tbody>
                    <tr scope="row" *ngFor="let item of filteredTruckersList" [class.selected]="item.isSelected" (click)="selectTrucker(item)">
                        <td>{{item.customerName}}</td>
                        <td>{{item.customerCode}}</td>
                        <td>
                            <div class="executed-bar">
                                <div class="executed-bar-fill"
                                     [class.complete]="getTruckerExecutedPercentage(item) === 100"
                                     [class.partial]="getTruckerExecutedPercentage(item) > 0 && getTruckerExecutedPercentage(item) < 100"
                                     [class.none]="getTruckerExecutedPercentage(item) === 0"
                                     [style.width.%]="getTruckerExecutedPercentage(item)"></div>
                                <span class="executed-bar-label" [class.complete]="getTruckerExecutedPercentage(item) === 100">{{item.executedLoads}}/{{item.totalLoads}}</span>
                            </div>
                        </td>
                        <td>
                            <a href="#" class="send-btn" title="Send Dispatches" data-bs-toggle="modal" attr.data-bs-target="#{{confirmTruckersFormId}}"
                               (click)="confirmTrucker(item.customerId)" *ngIf="item.customerId > 0">
                                <i class="fa-solid fa-envelope fa"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="selectedTrucker != 0" class="col-md me-2 border rounded ms-2 table-container" [style.height.px]="tableHeight">
        <table class="table table-sm table-borderless table-hover mt-2">
            <thead>
                <tr class="row-cols-auto">
                    <th></th>
                    <th class="col-sm">Origin</th>
                    <th class="col-sm">Origin City</th>
                    <th class="col-sm">Origin Cust</th>
                    <th class="col-sm">Destination</th>
                    <th class="col-sm">Dest City</th>
                    <th class="col-sm">Dest Cust</th>
                    <th class="col-sm text-center">Comm</th>
                    <th class="col-sm text-center">Round</th>
                    <th class="col-sm text-center">Loads</th>
                    <th class="col-sm text-center" style="min-width: 100px;">Executed</th>
                    <th class="col-sm text-center">Rate</th>
                    <th class="col-sm text-center" title="Email Status">Email ST</th>
                    <th class="col-sm text-center" title="Roger Status">Roger ST</th>
                    <th class="col-sm text-center">Entered By</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let dispatch of dispatchList">
                    <td>
                        <div class="dropdown">
                            <a href="#" class="grid-icon-btn elipsis-btn" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa-solid fa-ellipsis fa-lg"></i>
                            </a>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a href="#" class="grid-icon-btn edit-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{dispatchFormId}}" (click)="editDispatch(dispatch.dispatchId)">
                                    <i class="fa-solid fa-pen-to-square fa"></i>
                                    <span class="ps-2">Edit</span>
                                </a>
                                <a href="#" class="grid-icon-btn edit-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{copyDispatchModalId}}" (click)="copyDispatch(dispatch.dispatchId)">
                                    <i class="fa-solid fa-copy fa"></i>
                                    <span class="ps-2">Copy</span>
                                </a>
                                <a href="#" class="grid-icon-btn delete-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{deleteFormId}}" (click)="deleteDispatch(dispatch.dispatchId)">
                                    <i class="fa-solid fa-trash-can fa"></i>
                                    <span class="ps-2">Delete</span>
                                </a>
                                <a href="#" class="grid-icon-btn move-split-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{moveSplitFormId}}" (click)="moveSplitDispatch(dispatch.scheduleId, dispatch.dispatchId, dispatch.locationType)">
                                    <i class="fa-solid fa-pie-chart fa"></i>
                                    <span class="ps-2">Move/Split</span>
                                </a>
                                <a href="#" class="grid-icon-btn alert-trucker-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{alertTruckerFormId}}" (click)="alertTrucker(dispatch.scheduleId, dispatch.dispatchId, false)">
                                    <i class="fa-solid fa-bell fa"></i>
                                    <span class="ps-2">Alert Trucker</span>
                                </a>
                                <a href="#" class="grid-icon-btn question-email-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{emailQuestionFormId}}" (click)="getEmailQuestionDetails(dispatch.scheduleId, dispatch.dispatchId)">
                                    <i class="fa-solid fa-question-circle fa"></i>
                                    <span class="ps-2">Email Question</span>
                                </a>
                                <a href="#" class="grid-icon-btn send-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{confirmDispatchFormId}}" (click)="sendDispatch(dispatch.dispatchId)" *ngIf="dispatch.truckerId > 0">
                                    <i class="fa-solid fa-envelope fa"></i>
                                    <span class="ps-2">Send Dispatch</span>
                                </a>
                                <a href="#" class="grid-icon-btn roger-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{loadsStatusFormId}}" (click)="showRogerLoadsStatus(dispatch.dispatchId)" *ngIf="dispatch.rogerStatus">
                                    <i class="fa-solid fa-registered fa"></i>
                                    <span class="ps-2">Loads Status</span>
                                </a>
                                <a href="#" class="grid-icon-btn round-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{roundFormId}}" (click)="openRound(dispatch.roundId, dispatch.dispatchId)">
                                    <i class="fa-solid fa-circle-nodes fa"></i>
                                    <span class="ps-2">Round</span>
                                </a>
                                <a href="#" class="grid-icon-btn copy-round-btn dropdown-item" data-bs-toggle="modal" attr.data-bs-target="#{{copyRoundFormId}}" (click)="openRound(dispatch.roundId, dispatch.dispatchId)" *ngIf="dispatch.roundId > 0">
                                    <i class="fa-solid fa-object-ungroup fa"></i>
                                    <span class="ps-2">Copy Round</span>
                                </a>
                            </div>
                        </div>
                    </td>
                    <td class="ellipsis-cell" title="{{dispatch.originName}}" [ngClass]="{'rounds-alert': dispatch.round && dispatch.round.trim() !== ''}">{{dispatch.originName}}</td>
                    <td class="ellipsis-cell" title="{{dispatch.originCity}}{{dispatch.originState ? ', ' + dispatch.originState : ''}}">{{dispatch.originCity}}{{dispatch.originState ? ', ' + dispatch.originState : ''}}</td>
                    <td class="ellipsis-cell" title="{{dispatch.customerName}}">{{dispatch.customerName}}</td>
                    <td class="ellipsis-cell" title="{{dispatch.destinationName}}" [ngClass]="{'rounds-alert': dispatch.round && dispatch.round.trim() !== ''}">{{dispatch.destinationName}}</td>
                    <td class="ellipsis-cell" title="{{dispatch.destinationCity}}{{dispatch.destinationState ? ', ' + dispatch.destinationState : ''}}">{{dispatch.destinationCity}}{{dispatch.destinationState ? ', ' + dispatch.destinationState : ''}}</td>
                    <td class="ellipsis-cell" title="{{dispatch.destinationCustomerName}}">{{dispatch.destinationCustomerName}}</td>
                    <td class="text-center">{{dispatch.commodityCode}}</td>
                    <td class="text-center rounds-alert">{{dispatch.round}}</td>
                    <td class="text-center">{{dispatch.loads}}</td>
                    <td class="text-center">
                        <div class="executed-bar">
                            <div class="executed-bar-fill"
                                 [class.complete]="getExecutedPercentage(dispatch) === 100"
                                 [class.partial]="getExecutedPercentage(dispatch) > 0 && getExecutedPercentage(dispatch) < 100"
                                 [class.none]="getExecutedPercentage(dispatch) === 0"
                                 [style.width.%]="getExecutedPercentage(dispatch)"></div>
                            <span class="executed-bar-label" [class.complete]="getExecutedPercentage(dispatch) === 100">{{getExecutedCount(dispatch)}}/{{getTotalCount(dispatch)}}</span>
                        </div>
                    </td>
                    <td class="text-center">{{dispatch.rate}}</td>
                    <td class="text-center">{{dispatch.emailStatus}}</td>
                    <td class="text-center">{{dispatch.rogerStatus}}</td>
                    <td class="text-center">{{dispatch.enteredBy}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<dispatch-form [dispatchParameters]="dispatchFormParams" [dispatchFormId]="dispatchFormId" (saveComplete)="getTruckerDispatchesById()" (deleteComplete)="getTruckerDispatchesById()"></dispatch-form>

<copy-dispatch [copyDispatchParameters]="copyDispatchParameters" [copyDispatchModalId]="copyDispatchModalId" (saveComplete)="getTruckerDispatchesById()"></copy-dispatch>

<move-split-dispatch-form [moveSplitDispatchFormParams]="moveSplitDispatchFormParams" [moveSplitFormId]="moveSplitFormId" (saveComplete)="scheduleSaveComplete($event)"></move-split-dispatch-form>

<alert-trucker-form [alertParameters]="alertTruckerParams" [alertTruckerFormId]="alertTruckerFormId"></alert-trucker-form>

<app-email-question-form [emailQuestionParameters]="emailQuestionParams" [emailQuestionFormId]="emailQuestionFormId"></app-email-question-form>

<round-form [parameters]="roundParams" [roundFormId]="roundFormId" (roundComplete)="roundComplete($event)"></round-form>

<copy-round [parameters]="roundParams" [copyRoundFormId]="copyRoundFormId" (roundComplete)="roundComplete($event)"></copy-round>

<loads-status [loadsStatusModalId]="loadsStatusFormId" [dispatchId]="loadsStatusDispatchId" [showAllRecords]="true"></loads-status>

<confirm-dispatch [dispatchId]="sendDispatchId" [confirmDispatchFormId]="confirmDispatchFormId" [confirmTruckersFormId]="confirmTruckersFormId" [refresh]="sendDispatchRefresh" (sendComplete)="getTruckerDispatchesById()"></confirm-dispatch>

<confirm-truckers [scheduleParameters]="scheduleParameters" [confirmTruckersFormId]="confirmTruckersFormId" [truckerId]="confirmTruckerId" [refresh]="sendDispatchRefresh" (sendComplete)="getTruckerDispatchesById()"></confirm-truckers>

<delete-confirm #deleteConfirmChildComponent [deleteItemParameters]="deleteItemParams" [deleteFormId]="deleteFormId" (confirmEmitter)="deleteItem($event, deleteItemParams)"></delete-confirm>

<toast-notification #toastNotification></toast-notification>